import { css, type Theme } from "@emotion/react";

export const barWrapper = (theme: Theme) => css`
  & > div:not(:first-of-type) {
    & > * {
      border-top: solid 1px ${theme.success.borderActive};
    }
  }
`;
